import {
  BATTERIES_REQUEST,
  BATTERIES_SUCCESS,
  BATTERIES_FAILURE,
} from '../actions/batteries'

const INITIAL_STATE = {
  batteries: null,
  error: null,
  loading: false,
}

const batteriesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case BATTERIES_REQUEST:
      return { ...state, error: null, loading: true }
    case BATTERIES_SUCCESS:
      return { ...state, batteries: action.response, error: null, loading: false }
    case BATTERIES_FAILURE:
      return { ...state, error: action.error, loading: false }
    default:
      return state
  }
}

export default batteriesReducer
